import { createElement } from "react";
import React from "react";
import { Select, Title3, CardHeader, Card } from "@fluentui/react-components";
import { createObj } from "./fable_modules/fable-library-js.4.24.0/Util.js";
import { toConsole, interpolate, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { reactApi } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray, singleton } from "./fable_modules/fable-library-js.4.24.0/List.js";
import { reactApi as reactApi_1 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { iterate, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.24.0/Seq.js";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import { startAsPromise } from "./fable_modules/fable-library-js.4.24.0/Async.js";
import { Course } from "./ApiClient.jsx";
import { toArray } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { tryParse } from "./fable_modules/fable-library-js.4.24.0/Int32.js";
import { FSharpRef } from "./fable_modules/fable-library-js.4.24.0/Types.js";
import { reactApi as reactApi_2 } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { map } from "./fable_modules/fable-library-js.4.24.0/Array.js";

export function CourseCard(course) {
    let elems, el_2, el;
    const el_4 = Card;
    return createElement(el_4, createObj(singleton((elems = [(el_2 = CardHeader, createElement(el_2, {
        header: (el = Title3, createElement(el, {
            children: toText(interpolate("%s%P() (%d%P())", [course.Name, course.Id])),
        })),
        description: course.Summary,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))]))));
}

export function CourseSelector() {
    let elems_2;
    const patternInput = reactApi_1.useState(undefined);
    const patternInput_1 = reactApi_1.useState("Ingen kurs valgt");
    const selectedId = patternInput_1[0];
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_2 = toList(delay(() => {
        let el_2, elems_1, el, elems;
        return append(singleton_1((el_2 = StackShim, createElement(el_2, createObj(ofArray([["horizontal", false], (elems_1 = [(el = Select, createElement(el, createObj(ofArray([["value", selectedId], ["onChange", (_arg, value_1_3) => {
            let tupledArg, outArg;
            const d = value_1_3;
            patternInput_1[1](d.value);
            iterate((id) => {
                const pr = startAsPromise(Course.GetCourse(id));
                void (pr.then((res) => {
                    if (res.tag === 1) {
                        toConsole(`${res.fields[0]}`);
                    }
                    else {
                        patternInput[1](res.fields[0]);
                    }
                }));
            }, toArray((tupledArg = ((outArg = 0, [tryParse(d.value, 511, false, 32, new FSharpRef(() => outArg, (v) => {
                outArg = (v | 0);
            })), outArg])), tupledArg[0] ? tupledArg[1] : undefined)));
        }], (elems = [createElement("option", {
            children: ["Ingen kurs valgt"],
        }), createElement("option", {
            children: [`${1}`],
        }), createElement("option", {
            children: [`${2}`],
        }), createElement("option", {
            children: [`${3}`],
        }), createElement("option", {
            children: [`${4}`],
        })], ["children", reactApi.Children.toArray(Array.from(elems))])]))))], ["children", reactApi_2.Children.toArray(Array.from(elems_1))])]))))), delay(() => {
            let el_4, el_6;
            if (selectedId === "Ingen kurs valgt") {
                return singleton_1((el_4 = Title3, createElement(el_4, {
                    children: "Velg et kurs for å vise det her",
                })));
            }
            else {
                const matchValue = patternInput[0];
                return (matchValue == null) ? singleton_1((el_6 = Title3, createElement(el_6, {
                    children: `Fant ikke kurset med id ${selectedId}`,
                }))) : singleton_1(createElement(CourseCard, matchValue));
            }
        }));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

export function AllCourses() {
    let elems;
    const patternInput = reactApi_1.useState([]);
    useEffectOnce(() => {
        const pr = startAsPromise(Course.GetAllCourses());
        void (pr.then((res) => {
            if (res.tag === 1) {
                toConsole(`${res.fields[0]}`);
            }
            else {
                patternInput[1](res.fields[0]);
            }
        }));
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems = toList(delay(() => map((course) => createElement(CourseCard, course), patternInput[0]))), ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

export function CoursePage() {
    let elems;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 50 + "px ",
    }], (elems = [createElement(AllCourses, null), createElement(CourseSelector, null)], ["children", reactApi_1.Children.toArray(Array.from(elems))])])));
}

//# sourceMappingURL=Course.jsx.map
